<mat-drawer-container hasBackdrop="true" (backdropClick)="backdropClick()">
  <mat-drawer #userDrawer position="start" mode="over">
    <app-user-menu-drawer></app-user-menu-drawer>
  </mat-drawer>
  <mat-drawer-content>
    <app-loading></app-loading>
    <app-toaster></app-toaster>
    <router-outlet></router-outlet>
  </mat-drawer-content>
  <mat-drawer #installmentsDrawer position="end" mode="over">
    <app-installments-dropdown-drawer></app-installments-dropdown-drawer>
  </mat-drawer>
</mat-drawer-container>
